/* eslint-disable */
import React, { createContext, useContext, useEffect, useState } from "react";
import { getSecondaryCriteriaPublishConfig } from "../../../api/user";
import { StoreConfigDetails, StoreProfileResponse } from "../../../types/types";

interface FeatureFlagContextType {
  disableSecondaryCriteriaPublish: string;
}

const FeatureFlagContext = createContext<FeatureFlagContextType>({
  disableSecondaryCriteriaPublish: '0'
});

export const useFeatureFlag = () => useContext(FeatureFlagContext);

export function FeatureFlagProvider(props: any) {
  const [disableSecondaryCriteriaPublish, setDisableSecondaryCriteriaPublish] = useState<string>('0');

  useEffect(() => {
    fetchFeatureFlag();
  }, []);

  const fetchFeatureFlag = async () => {
    const storeNumber = String(window.sessionStorage.getItem('storeNumber'));

    try {
      const configRes = await getSecondaryCriteriaPublishConfig({
        storeNumbers: [storeNumber],
        paramKeyNames: ['DisableSecondaryCriteriaPublish'],
      });

      const publishFlagValue = extractFlagValue(configRes, 'DisableSecondaryCriteriaPublish');
      
      setDisableSecondaryCriteriaPublish(publishFlagValue);
    } catch (error) {
      console.error('Error fetching feature flag config:', error);
      setDisableSecondaryCriteriaPublish('0');
    }
  };


  const extractFlagValue = (configRes: any, paramKeyName: string): string => {
    if (configRes?.status !== 200) {
      return '0';
    }

    const data = configRes?.data as StoreProfileResponse;
    const configDetails = data?.storeProfileResponse?.configDetails?.[0]?.configDetails;
    
    if (!configDetails) {
      return '0';
    }

    const flagConfig = configDetails.find(
      (item: StoreConfigDetails) => item.paramKeyName === paramKeyName
    );

    return flagConfig?.paramValue || '0';
  };

  return (
    <FeatureFlagContext.Provider value={{ disableSecondaryCriteriaPublish }}>
      {props.children}
    </FeatureFlagContext.Provider>
  );
}
